const USER_FRIENDLY_ERROR_MESSAGE = {
  PermissionDenied: `You don't have permission to upload a playbook`,
};

const GRPC_ERROR_CODE = {
  7: 'PermissionDenied',
};

export { USER_FRIENDLY_ERROR_MESSAGE, GRPC_ERROR_CODE };
